<template>
  <div
    class="w-full h-full flex flex-col bg-white group cursor-pointer relative shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] transition-all duration-300 rounded-2xl"
  >
    <!-- Image & Video -->
    <div
      v-if="media"
      class="w-full relative overflow-hidden flex rounded-t-2xl"
      :class="[
        background === 'transparent'
          ? 'bg-brand-first bg-opacity-15'
          : 'bg-brand-background',
      ]"
    >
      <!-- Image -->
      <div
        class="w-full flex overflow-hidden relative lg:group-hover:scale-110 duration-500"
      >
        <NuxtLink class="flex w-full" :to="localePath(button?.link)">
          <AtomsImage
            v-if="media?.mime?.includes('image')"
            class="w-full"
            :class="[
              getAspectClass(mediaSize),
              {
                'object-contain': objectFit === 'contain',
                'object-cover object-center':
                  !objectFit || objectFit === 'cover',
              },
            ]"
            :media="media"
            sizeHint="third"
            :alt="media?.alternativeText ?? title ?? media?.hash ?? media?.name"
          />
        </NuxtLink>
      </div>
      <!-- Image -->

      <!-- Video -->
      <AtomsVideo
        v-if="media?.mime?.includes('video')"
        :src="media?.formats?.large?.url ?? media?.url"
        :type="media?.mime"
        :autoplay="true"
        class="w-full object-cover object-center"
        :class="getAspectClass(mediaSize)"
      />
      <!-- Video -->
    </div>
    <!-- Image & Video -->

    <!-- Text -->
    <div
      v-if="pin || title || description || button"
      class="w-full p-6 lg:p-8 flex flex-col grow gap-2 lg:gap-3"
      :class="[
        {
          'items-center': position === 'center',
          'items-end': position === 'right',
        },
        { '!pb-[100px]': button?.link || button?.enabled },
      ]"
    >
      <!-- Pin -->
      <span
        v-if="pin"
        class="w-full text-[11px] uppercase tracking-widest font-bold text-black mb-1 opacity-70"
        :class="[
          position === 'center'
            ? 'text-center'
            : position === 'right'
              ? ' text-right'
              : 'text-left',
          background === 'first'
            ? '!text-black'
            : background === 'second'
              ? 'text-black'
              : 'text-black',
        ]"
        v-html="pin"
      ></span>
      <!-- Pin -->

      <!-- Title -->
      <h3
        v-if="title"
        class="w-full text-[18px] lg:text-[22px] font-bold text-gray-900 leading-snug"
        :class="[
          position === 'center'
            ? 'text-center'
            : position === 'right'
              ? ' text-right'
              : 'text-left',
          background === 'first'
            ? '!text-brand-first'
            : background === 'second'
              ? 'text-brand-second'
              : 'text-gray-900',
        ]"
        v-html="title"
      ></h3>
      <!-- Title -->

      <!-- Description -->
      <p
        v-if="description"
        class="w-full text-[14.5px] lg:text-[16px] leading-relaxed mt-1 text-gray-500 line-clamp-3"
        :class="[
          position === 'center'
            ? 'text-center'
            : position === 'right'
              ? ' text-right'
              : 'text-left',
          background === 'first'
            ? '!text-gray-500'
            : background === 'second'
              ? 'text-gray-600'
              : 'text-gray-500',
        ]"
        v-html="description"
      ></p>
      <!-- Description -->
    </div>
    <!-- Text -->

    <!-- Button -->
    <div
      class="!absolute !bottom-8 w-full flex px-6 lg:px-8"
      :class="
        position === 'center'
          ? 'justify-center !left-0'
          : position === 'right'
            ? 'justify-end !left-0'
            : ' justify-start !left-0'
      "
    >
      <AtomsButton
        v-if="button?.enabled"
        :label="button?.label"
        :link="button?.link"
        :target="button?.target"
        :icon="button?.icon"
        :iconPosition="button?.iconPosition"
        :color="button?.color"
        :disabled="button?.disabled"
        :enabled="button?.enabled"
      />
    </div>

    <!-- Button -->
  </div>
</template>
<script setup>
import { useLocalePath } from "#i18n";
import { computed } from "vue";
import { useSiteSettingsStore } from "@/store/index";
import { getAspectClass } from "~/composables/utils";

const siteSettingsStore = useSiteSettingsStore();
const localePath = useLocalePath();
const props = defineProps({
  pin: { type: String },
  title: {
    type: String,
  },
  description: {
    type: String,
  },
  link: { type: String, default: null },
  button: {
    type: Object,
  },
  media: {
    type: Object,
  },
  position: { type: String, default: "left" },
  mediaSize: { type: String },
  objectFit: { type: String },
  background: { type: String },
});
</script>
